import { gql } from '@apollo/client/core';
import React from 'react';
import { Box, Text } from '.';
import { useProduct } from '../Product';

export default function Debug({ product: data, style, ...rest }) {
  const product = useProduct(data);
  return (
    <Box
      style={[
        {
          position: 'absolute',
          bottom: '2mm',
          left: 0,
          right: 0,
          color: '#ccc',
        },
        style,
      ]}
      {...rest}
    >
      <Text style={{ color: '#efefefef', fontSize: 8, textAlign: 'center' }}>
        Product ID: {product.productId} / CompanyId ID:{' '}
        {product?.companyProfile?.companyId}
      </Text>
    </Box>
  );
}

Debug.fragment = gql`
  fragment Debug on Product {
    productId
    companyProfile {
      companyId
    }
  }
`;
